export const CLASS_NAMES = {
  /*
   * when dragged block is over column and column accepts it's type
   * it indicates so dropping such block in the hovered column is possible
   */
  CAN_DROP: 'can-drop',
  /*
   * when droppable column accepts dragged block type
   */
  TYPE_ALLOWED: 'type-allowed',
  /*
   * when section column or email container are empty
   * it sets height of placeholder so it makes possible to drop in to column
   */
  EMPTY_COLUMN: 'empty-column',
  /*
   * when existing Block is dragged and going to be moved
   * it sets opacity of the dragged block
   */
  BLOCK_IS_MOVING: 'moving',
}

export const MAIL_TYPE_UPDATED = 2

export const VIEW_TYPES = {
  EDITOR: 'EDITOR',
  FILE_MANAGER_FROM_EDITOR: 'FILE_MANAGER_FROM_EDITOR',
  FILE_MANAGER_FROM_SIDEBAR: 'FILE_MANAGER_FROM_SIDEBAR',
}

export const HISTORY_LIMIT = 50

export const HISTORY_DELAY = 1000

export const PLANS_LEVELS = {
  START: 10,
  STANDARD: 20,
}
